import {
  Box,
  styled,
} from "@mui/material"
import UIIcon from "../../../components/UIIcon"

export const ContentContainer = styled(Box)({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  flex: 1,
  background: "#5c616e",
  padding: "24px 20px",
  position: "relative",
})

export const ScanArea = styled(Box)({
  position: "relative",
  width: "100%",
  maxWidth: 360,
  aspectRatio: "1 / 1",
})

export const ViewfinderOverlay = styled("svg")({
  position: "absolute",
  inset: 0,
  width: "100%",
  height: "100%",
  pointerEvents: "none",
})

export const CloseIcon = styled(UIIcon)({
  position: "absolute",
  top: "20px",
  right: "20px",
  background: "transparent",
  border: "none",
  cursor: "pointer",
  padding: 0,
  margin: 0,
  outline: "none",
  boxShadow: "none",
  borderRadius: "50%",
  width: "40px",
  height: "40px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  color: "#fff",
})
